// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC1-rIvaYfuLWDi9Ip55p77pll-rkRMo1s",
    authDomain: "the-tour-bees-cdf1c.firebaseapp.com",
    projectId: "the-tour-bees-cdf1c",
    storageBucket: "the-tour-bees-cdf1c.appspot.com",
    messagingSenderId: "801573594832",
    appId: "1:801573594832:web:19b716c07b4addc4b5e0d5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;